import type { FilterDefinition, FilterHandler } from '../engine/types';
import { FilterId, FilterType, type ListFilter } from '../types/filters';

export const seniorityDefinition: FilterDefinition<ListFilter> = {
  id: FilterId.SENIORITY,
  name: 'Seniority',
  selectionListId: 'seniority',
  selections: [],
  type: FilterType.LIST,
  isVisible: true,
};

export const seniorityHandler: FilterHandler<ListFilter> = {
  isActive(currentFilterState: ListFilter) {
    return currentFilterState.selections.length > 0;
  },
  isDefault(currentFilterState: ListFilter) {
    return currentFilterState.selections.length === 0;
  },
  getEffectiveFilter(currentFilterState: ListFilter) {
    return { ...currentFilterState };
  },
  getRequiredSelectionListIds(definition: FilterDefinition<ListFilter>) {
    return [definition.selectionListId];
  },
};
